import {Checkbox} from '@material-ui/core'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline'
import React from 'react'
import useStyles from './ReportsTableCheckbox.styles'

type Props = {
  checked: boolean
  onChange: (checked: boolean) => void
  'data-testid': string
}

function ReportsTableCheckbox(props: Props) {
  const {checked, onChange} = props
  const classes = useStyles()

  function handleChange(event) {
    const checked = event.target.checked
    onChange(checked)
  }

  return (
    <Checkbox
      className={classes.root}
      color="primary"
      checked={checked}
      onChange={handleChange}
      data-testid={props['data-testid']}
      icon={<CheckCircleOutlineIcon />}
      checkedIcon={<CheckCircleIcon />}
    />
  )
}

export default ReportsTableCheckbox
